<template>
  <div id="app">
    <el-container class="top">
      <div class="container">
        <el-header>
          <div class="top_indent">
            <div style="padding-left:15px">
              <span>欢迎访问中南林业科技大学期刊社！</span>
            </div>
            <div style="padding-right:10px;">
              <ul>
                <li><a href="https://www.csuft.edu.cn" target="_blank">中南林业科技大学官网</a></li>
                <li class="pclist" style="padding:0;">|</li>
                <!-- <li><a href="http://lib.csuft.edu.cn:8080" target="_blank">图书馆</a></li>
                <li class="pclist" style="padding:0;">|</li> -->
                <!-- <li><router-link to="/Login?Login=2">管理员入口</router-link></li> -->
                <li @click="toLogin" style="cursor:pointer">管理员入口</li>
              </ul>
            </div>
          </div>
          <el-row class="logo-bg">
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" style="padding-left: 15px;">
              <div class="grid-content bg-purple logo"></div>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <div class="grid-content bg-purple-light" style="height:80px;margin:25px;">
                <div class="clearfix"></div>
                <div class="index-nav nav_menu">
                  <div class="index-nav-frame clearfix">
                    <!-- logo -->
                    <div
                      class="nav-small"
                      tabindex="-1"
                      @click="onMnav"
                      v-if="!isgzh"
                    >
                      <div
                        class="nav-small-focus"
                        tabindex="-1"
                        v-if="isgzhl != 2"
                      ></div>
                      <img src="../assets/images/icon.png" v-if="isgzhl != 2" />
                    </div>
                    <div
                      v-for="(item, index) in NavList"
                      :key="index"
                      class="index-nav-frame-line pclist"
                    >
                      <span @click="$router.push(item.path)">{{
                        item.name
                      }}</span>
                      <span v-if="item.children" class="rotator">
                        <img src="../assets/images/down.png" />
                      </span>
                      <div
                        v-if="item.children"
                        class="index-nav-frame-line-center"
                        :class="'list' + index"
                      >
                        <div
                          class="index-nav-frame-line-li"
                          :class="'list' + index + '' + i"
                          v-for="(val, i) in item.children"
                          :key="i"
                        >
                          <span @click="$router.push(val.path)">{{
                            val.name
                          }}</span>
                        </div>
                      </div>
                      <div class="index-nav-frame-line-focus"></div>
                    </div>
                    <div v-if="ismnav" ref="treeWrap">
                      <div
                        v-for="(items, indexs) in MNavList"
                        :key="10 + indexs"
                        class="index-nav-frame-line mobList index-nav-frame-linem"
                        @click="topath(items.path)"
                      >
                        <span>{{ items.name }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
        </el-header>
      </div>
    </el-container>
  </div>
</template>

<script>
import Search from "./Home/Search";
export default {
  name: "CommonHearde",
  components: {
    Search,
  },
  data() {
    return {
      isycb: false,
      ismnav: false,
      isgzhl: 0,
      islang: true,
      NavList: [
        { name: "首页", path: "/" },
        
        { name: "期刊社简介", path: "/FixedBody?ItemId=1100" },
        {
          name: "通知公告",
          path: "/NewsList",
        },
        {
          name: "联系我们",
          path: "/FixedBody?ItemId=50",
        },
      ],
      MNavList: [
       { name: "首页", path: "/" },
        
        { name: "期刊社简介", path: "/FixedBody?ItemId=1100" },
        {
          name: "通知公告",
          path: "/NewsList",
        },
        {
          name: "联系我们",
          path: "/FixedBody?ItemId=50",
        },
      ],
    };
  },
  props: ["isgzh"],
  created() {
    if (sessionStorage.getItem("SetItem")) {
      let SetItem = JSON.parse(sessionStorage.getItem("SetItem"));
      SetItem.map((item) => {
        if (item.SetItemID == 4530) {
          item.Item_Value == "是" ? (this.isycb = true) : (this.isycb = false);
        }
        if (item.SetItemID == 2900) {
          item.Item_Value == "是"
            ? (this.islang = true)
            : (this.islang = false);
        }
      });
    }
  },
  mounted() {
    let _this = this;
    if (this.$route.query) {
      this.isgzhl = this.$route.query.isgzh;
    }
    document.addEventListener("mouseup", (e) => {
      let tree = this.$refs.treeWrap;
      if (tree) {
        if (!tree.contains(e.target)) {
          this.ismnav = false;
        }
      }
    });
  },
  methods: {
    onMnav() {
      if (this.ismnav) {
        this.ismnav = false;
      } else {
        this.ismnav = true;
      }
    },
    topath(url) {
      this.$router.push(url);
      this.ismnav = false;
    },
    toLogin(){
      if(window.localStorage.getItem("userInfo")){
         var urldomain = "/editor/#/editor/Index";
				 	 window.location.href=urldomain;
      }else{
        this.$router.push('/Login?Login=2')
      }
      
    }
  },
};
</script>
<style scoped>
.index-nav-frame-linem a {
  width: 100%;
  display: inline-block;
}
@media (max-width: 768px) {
  .language {
    position: absolute;
    top: 5px;
    right: 10px;
  }
  .quick {
    margin-top: -40px !important;
  }
  .logo-bg{
    background: none !important;
  }
  .top_indent ul li{
    float: inherit !important;
  }
  .top_indent{
    display: block !important;
  }
}
.top_indent{
  
  width: 100%;
  height: 33px;
  background: #0f84aa;
  line-height: 33px;
  color: #fff;
  display: flex;
  justify-content: space-between;
  -webkit-justify-content:-webkit-space-between;
  -moz-justify-content:-moz-space-between
}
.top_indent ul li{
  float: left;
  padding: 0 10px;

}
.top_indent ul li a{
  color: #fff;
}
.logo-bg{
  background: url('../assets/images/logo_bg.png') no-repeat;
  background-size: cover;
}
</style>
